import { Award, Download } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

interface BadgeDisplayProps {
  badgeLevel: 'gold' | 'silver' | 'bronze' | null;
  score: number;
  certificateUrl?: string;
  className?: string;
}

export const BadgeDisplay = ({ badgeLevel, score, certificateUrl, className }: BadgeDisplayProps) => {
  const getBadgeColor = (level: string) => {
    switch (level) {
      case 'gold':
        return 'bg-yellow-500 text-yellow-900 border-yellow-600';
      case 'silver':
        return 'bg-gray-400 text-gray-900 border-gray-500';
      case 'bronze':
        return 'bg-orange-600 text-orange-100 border-orange-700';
      default:
        return 'bg-gray-200 text-gray-700 border-gray-300';
    }
  };

  const getBadgeIcon = () => {
    if (!badgeLevel) return null;
    
    return (
      <Award 
        className={`h-8 w-8 ${
          badgeLevel === 'gold' ? 'text-yellow-500' :
          badgeLevel === 'silver' ? 'text-gray-400' :
          'text-orange-600'
        }`} 
      />
    );
  };

  const downloadCertificate = () => {
    if (certificateUrl) {
      window.open(certificateUrl, '_blank');
    }
  };

  if (!badgeLevel) {
    return (
      <Card className={className}>
        <CardContent className="flex items-center justify-center p-6">
          <div className="text-center">
            <p className="text-muted-foreground">Score: {score}%</p>
            <p className="text-sm text-muted-foreground">Minimum 70% required for badge</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className={className}>
      <CardContent className="flex items-center justify-between p-6">
        <div className="flex items-center gap-4">
          {getBadgeIcon()}
          <div>
            <Badge className={getBadgeColor(badgeLevel)}>
              {badgeLevel.toUpperCase()} BADGE
            </Badge>
            <p className="text-sm text-muted-foreground mt-1">Score: {score}%</p>
          </div>
        </div>
        
        {certificateUrl && (
          <Button 
            onClick={downloadCertificate}
            variant="outline"
            size="sm"
            className="flex items-center gap-2"
          >
            <Download className="h-4 w-4" />
            Certificate
          </Button>
        )}
      </CardContent>
    </Card>
  );
};